import { render, staticRenderFns } from "./HmPurchaseGoodsTransfer.vue?vue&type=template&id=5d09095c&scoped=true&"
import script from "./HmPurchaseGoodsTransfer.vue?vue&type=script&lang=js&"
export * from "./HmPurchaseGoodsTransfer.vue?vue&type=script&lang=js&"
import style0 from "./HmPurchaseGoodsTransfer.vue?vue&type=style&index=0&id=5d09095c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d09095c",
  null
  
)

component.options.__file = "HmPurchaseGoodsTransfer.vue"
export default component.exports